import { TabsContext } from './TabsContext';
import { TabsNotificationProvider } from './TabsNotificationProvider.main';

export { TabsContext, TabsNotificationProvider };
